import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import { fetchFahrerFuhrpark, sendFahrerMails, removeFahrer } from '../../actions'
import nfctag_ok from '../../img/nfc-tag-grey.png'
import nfctag_warn from '../../img/nfc-tag-orange-half.png'
import PDFFile from './FahrerPdf2'
import FahrerCSVDownload from './FahrerCSVDownload'

/*
const createFNLink = ({ onHover, children }) => {
	<div className="hover">
		<div className="hover__no-hover">{children}</div>
		<div className="hover_hover">{onHover}</div>
	</div>
}
*/

class FahrerList extends Component {

	constructor (props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
		this.handleEmailVerschicken = this.handleEmailVerschicken.bind(this);
		this.handleEmailLoeschen = this.handleEmailLoeschen.bind(this);
		this.computeFahrerCredits = this.computeFahrerCredits.bind(this);
		this.state = {
			selectedRows: [],
			isShowingEmailError: false,
			modalText: "Sie haben keine Email zum Verschicken ausgewählt."
		}
	}

	componentDidMount() {
		console.log("componentDidMount in der Fahrerliste.");
		this.props.fetchFahrerFuhrpark();
	}

	toggleRow(id) {
		const isIncluded = this.state.selectedRows.includes(id);

		if (!isIncluded) {
			this.setState({ selectedRows: [...this.state.selectedRows, id]});
		} else {
			var array = [...this.state.selectedRows];
			const index = array.indexOf(id);
			array.splice(index, 1);
			this.setState({selectedRows: array});
		}
	}

	testSelected(id) {
		return this.state.selectedRows.includes(id);
	}

  handleClick(e) {
		;
	}

	handleChange(e) {
		;
	}

	compareFahrer(a,b) {

		var akrit = a.email.toLowerCase();
		var bkrit = b.email.toLowerCase();

		if (a.fuehrerschein !== undefined && a.fuehrerschein !== null && a.fuehrerschein.length > 0) {
			akrit = a.fuehrerschein[0].nachname.toLowerCase();
		}

		if (b.fuehrerschein !== undefined && b.fuehrerschein !== null && b.fuehrerschein.length > 0) {
			bkrit = b.fuehrerschein[0].nachname.toLowerCase();
		}

		if (akrit < bkrit) {
			return -1;
		}
		if (akrit > bkrit) {
			return 1;
		}
		return 0;
	}

	handleEmailVerschicken(e) {
		e.preventDefault();

		const emailListLength = this.state.selectedRows.length;

		if (emailListLength > 0) {
			this.props.sendFahrerMails(this.state.selectedRows);
			this.setState({selectedRows: []});
		} 
	}

	handleEmailLoeschen(e) {
		e.preventDefault();

		const emailListLength = this.state.selectedRows.length;
		if (emailListLength > 0) {

			this.props.removeFahrer(this.state.selectedRows);
		}
	}

	localDateString(einDatum, mitHaekchen=true) {
		const d = new Date(einDatum);

		if (einDatum === undefined) {
			return ''
		}

		return (
			<React.Fragment>
				<span>{`${d.getDate()}.${d.getMonth()+1}.${d.getFullYear()}`}</span>
				{ mitHaekchen &&
				<span> <i className="material-icons left" style={{verticalAlign: 'middle'}}>done</i></span> }
			</React.Fragment>
		)
	}

	allLicencesValid(fuehrerscheine) {
		if (fuehrerscheine.length === 0) {
			return false;
		}
		const reducer = (accumulator, currentValue) => accumulator === currentValue ? currentValue : false;
		const licences = fuehrerscheine.map(f => f.licenseValid);
		//console.log("licences:", licences);
		return licences.reduce(reducer, true);
	}

	renderFahrerFuehrerschein(fuehrerscheine, fahrer_email, fahrer_id) {
		return fuehrerscheine.map((fuehrerschein, i) => {
			console.log("fuehrerschein._fahrer._id:", fuehrerschein._fahrer._id);
			console.log("fuehrerschein:", fuehrerschein);
			const editFnLink = "/fahrer/" + fahrer_email + "/" + fuehrerschein._id + "/editFn";
			const fn =
			<tr key={fuehrerschein._id + '_fn'} style={{ backgroundColor: this.testSelected(fahrer_id) ? '#efe':'#fff' }} onClick={(e) => this.toggleRow(fuehrerschein._fahrer._id)}>
				<td style={{ borderTop: 'none' }}></td>
				<td style={{ borderTop: 'none' }} colSpan="4">
					<img
						className=""
						src={(fuehrerschein.nfcUid !== undefined) ? nfctag_ok : nfctag_warn }
						alt="nfcTag"
						style={{height:'15px'}}
					/><span> Der Führerschein {fuehrerschein.licenseId} ist auf <em>{fuehrerschein.vorname} {fuehrerschein.nachname}</em> ausgestellt und</span>
					{fuehrerschein.licenseValid ? <span style={{color:'green'}}> überprüft</span> : <span style={{color: 'red'}}> nicht überprüft</span>}.
				</td>
				<td style={{ borderTop: 'none' }}>
					{fuehrerschein && <Link to={editFnLink}><i className="material-icons left">edit</i></Link>}
				</td>
				<td style={{ borderTop: 'none' }}>
					{fuehrerschein.licenseValid ? this.localDateString(fuehrerschein.licenseValidDate, false) : ''}
				</td>
			</tr>;
			return fn;
		})
	}

	renderFahrer() {
		const localFahrer = this.props.fahrer;
		localFahrer.sort(this.compareFahrer);

		return localFahrer.map((f,i) => {
			const newFnLink = "/fahrer/" + f.email + "/newFn";
			//console.log("f.fuehrerschein nach aenderung:", f.fuehrerschein);

			var fn_name;
			var fn;
			if ((f.fuehrerschein !== undefined) && (f.fuehrerschein !== null)) {
				//
				if (f.fuehrerschein.length > 0) {
					console.log("f.fuehrerschein:", f.fuehrerschein);

					var firstfn = f.fuehrerschein[0]
					var mehrere = f.fuehrerschein.length > 1;

					fn_name = firstfn.nachname + ", " + firstfn.vorname;

					if (mehrere) {
						if (fn_name === ', ') {
							fn_name = ""
						} else {
							fn_name = fn_name + " (und andere) - ";
						}

					} else {
						fn_name = fn_name + " - "
					}

					fn = this.renderFahrerFuehrerschein(f.fuehrerschein, f.email, f._id);
				}



			} else {
				fn = null;
			}

			const fr =
							<tr key={f._id} style={{ backgroundColor: this.testSelected(f._id) ? '#efe':'#fff'}} onClick={(e) => this.toggleRow(f._id)}>
								<td>{i+1}</td>
								<td><b>{fn_name}{f.email}</b></td>
								<td>{f.emailSentDate ? this.localDateString(f.emailSentDate) : <i className="material-icons left">remove</i>}</td>
								<td>{f.videoSeenDate ? this.localDateString(f.videoSeenDate) : <i className="material-icons left">remove</i>}</td>
								<td>
									{f.fuehrerschein && (f.fuehrerschein !== null) && (f.fuehrerschein.length > 0) &&
									<span>
										{this.allLicencesValid(f.fuehrerschein) ? <i className="material-icons left" style={{verticalAlign: 'middle'}}>done</i> : <span style={{color: 'red'}}>!!!</span>}
									</span>}
								</td>
								<td>
									<Link to={newFnLink}><i className="material-icons left" style={{verticalAlign: 'middle'}}>add</i></Link>
								</td>
								<td></td>
							</tr>


			//console.log("fn:", fn);
			return (
				[fr, fn]
			)
		})
	}

	computeFahrerCreditsUebrig() {
		const anzahlFahrer = this.props.fahrer.length;
		const anzahlCreditsSB = this.props.auth.credits; // SB steht für Schlauer Blauer
		const anzahlCreditsFn = this.props.auth.creditsFn;
		const anzahlCredits = anzahlCreditsSB + anzahlCreditsFn;
		const uebrig = anzahlCredits - anzahlFahrer;
		return uebrig;
	}

	computeFahrerCredits() {
		const resultat = {};

		if (this.props.fahrer) {
			const fahrerMitFuehrerschein = this.props.fahrer.filter(f =>
				f.fuehrerschein !== undefined
			);
			//console.log('fahrerMitFuehrerschein:', fahrerMitFuehrerschein)
			resultat.anzahlFahrer = this.props.fahrer.length;
			resultat.anzahlFahrerMitFuehrerschein = fahrerMitFuehrerschein.length;
			resultat.anzahlCreditsSB = this.props.auth.credits; // SB steht für Schlauer Blauer
			resultat.anzahlCreditsFn = this.props.auth.creditsFn;
			resultat.anzahlCredits = resultat.anzahlCreditsSB + resultat.anzahlCreditsFn;
			resultat.uebrig = resultat.anzahlCredits - resultat.anzahlFahrer;
			//console.log("fahrerCredits, resultat:", resultat);
		}
		return resultat;
	}

	render() {
		const fahrerCredits = this.computeFahrerCredits();
		return (
			<div>
				<h4 style={{fontStyle:'italic'}}>Teilnehmer</h4>
				<form>
				 <table className="table table-striped w-100">
					<thead style={{backgroundColor: '#e6e6e6'}}>
						<tr>
								<th>Nummer</th>
								<th>Email</th>
								<th>Email verschickt am</th>
								<th>Tutorial erfolgreich bestanden</th>
								<th colSpan="2">Führerschein?</th>
								<th>Letzter Check</th>
						</tr>
					</thead>
					<tbody>{this.renderFahrer()}
					</tbody>
				</table>
				{ this.props.auth &&
					<div className="row p-3 w-100">
						{fahrerCredits.anzahlFahrer} von insgesamt {fahrerCredits.anzahlCredits} Emailadressen vergeben, {fahrerCredits.uebrig} übrig.<br/>
					Führerscheinkontrolle gebucht: {fahrerCredits.anzahlFahrerMitFuehrerschein} von {fahrerCredits.anzahlCreditsFn}


					</div>}
				<div>
					<button
						className="float-right btn btn-default"
						disabled={this.state.selectedRows.length < 1}
						onClick={this.handleEmailLoeschen}>
							Löschen
					</button>
					<button
						className="float-right btn btn-default"
						style={{marginRight: '10px'}}
						disabled={this.state.selectedRows.length < 1}
						onClick={this.handleEmailVerschicken}>
							<span>Email{this.state.selectedRows.length > 1 && 's'}&nbsp;senden</span>
					</button>
					<PDFFile />
					<FahrerCSVDownload />
				</div>
			</form>
		</div>
		);
	}
}

const mapDispatchToProps = {
	fetchFahrerFuhrpark,
	sendFahrerMails,
	removeFahrer
}

function mapStateToProps({fahrer, auth, hinweis}) {
	return { fahrer, auth, hinweis }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(FahrerList);



// WEBPACK FOOTER //
// ./src/components/fahrer/FahrerList.js